import { Component, OnInit, ViewChildren } from '@angular/core';
import { DataService } from 'src/app/_services/data.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Item } from 'src/app/_core/_interface/item';
import { AuthService } from 'src/app/_services/auth.service';
import { anim, slideRight, slideUp } from 'src/app/animations';
import { Title } from '@angular/platform-browser';
// import { FileUploadComponent } from 'src/app/admin/file-upload/file-upload.component';

@Component({
  selector: 'app-test-view-construction-point',
  templateUrl: './test-view-construction-point.component.html',
  styleUrls: ['./test-view-construction-point.component.scss'],
  animations: [
    anim, slideRight, slideUp
  ]
})
export class TestViewConstructionPointComponent implements OnInit {
  projUid: any;
  constructionPoint: any;
  public compId;
  itemToEdit: Item;
  itemToview: Item;
  hidden = false;
  itemContent = false;
  mediaCollection = [];
  editState = false;
  fileUrl;
  collection = 'construction-points/';
  proj: Item;
  projTile: any;
  title: string;
  compTitle:string = '';


  // @ViewChildren(FileUploadComponent) child;


  constructor(private dataService: DataService,
    private route: ActivatedRoute,
    public auth: AuthService,
    private router: Router,
    private titleService: Title
  ) {
  }

  ngOnInit(): void {
    switch (window.location.host) {
      case 'spirical.net':
        this.compTitle = 'Spirikal';
        break;
      default:
    }
    this.projUid = this.route.snapshot.params.idp;
    // this.dataService
    //   .getConstructionPointsByProjId(this.projId)
    //   .subscribe(constructionPoints => {
    //     this.constructionPoint = constructionPoints;
    //   });

    this.dataService
      .getConstructionPointsByProjUid(this.projUid)
      .subscribe(constructionPoints => {
        this.constructionPoint = constructionPoints;
        if(this.constructionPoint[0]){
          this.projTile = this.constructionPoint[0].projTitle
        }
        this.pageTitle();
      });
    // this.dataService.getSpecProj(this.projUid).subscribe(proj => {
    //   this.proj = proj[0];
    //   console.log(proj[0]);
    // });
  }
  pageTitle() {
      if(this.projTile){
          this.title = this.compTitle + ' - ' + this.projTile + ' - ' + 'מעקב בנייה';
          this.titleService.setTitle(this.title);
        
      }
  }
  viewItemDetails(event, item) {
    this.itemContent = !this.itemContent;
    this.itemToview = item;
  }

  editItem(event, item) {
    this.editState = true;
    this.itemToEdit = item;
  }
  closeItem() {
    this.editState = false;
    this.itemToEdit = null;
  }

}
